export const presetForOtherThanHeaderItemsColors = [
  '#FFCBCB',
  '#FFE3CB',
  '#FF7979',
  '#FDA066',
  '#FDFFCB',
  '#D0EACC',
  '#695925',
  '#0F4103',
  '#BFEDDA',
  '#B0F1F4',
  '#034133',
  '#033341',
  '#93A4FF',
  '#D2ACFF',
  '#270341',
  '#410327',
  '#FFFFFF',
  '#BFBFBF',
  '#414141',
  '#000000',
];

export const presetHeaderColors = [
  '#FFCBCBAA',
  '#FFE3CBAA',
  '#FF7979AA',
  '#FDA066AA',
  '#FDFFCBAA',
  '#D0EACCAA',
  '#695925AA',
  '#0F4103AA',
  '#BFEDDAAA',
  '#B0F1F4AA',
  '#034133AA',
  '#033341AA',
  '#93A4FFAA',
  '#D2ACFFAA',
  '#270341AA',
  '#410327AA',
  '#FFFFFFAA',
  '#BFBFBFAA',
  '#414141AA',
  '#000000AA',
];
